import {useGrid, UseGridReturnType} from "common";
import {getUserLimit, getUserService, UserFormItem, UserListItem} from "./userApi";
import {createContext, useEffect, useState} from "react";

export type UseUserListReturnType = {
  grid: UseGridReturnType;
  userLimit: number;
  userCount: number;
  canInviteUser: boolean;
};

export const UserListContext = createContext<UseUserListReturnType>(
  {} as UseUserListReturnType
);


export default function useUserList(): UseUserListReturnType {
  const service = getUserService();
  const grid = useGrid<UserFormItem, UserListItem>({
    comaSeparatedSortPrarms: true,
    storageType: "urlParams",
    id: "Users",
    loadColumns: true,
    translationCategory: "Users",

    exportFilter: filter => ({
      ClientSearch: filter,
    }),
    ...service,
  });

  const [userLimit, setUserLimit] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const [canInviteUser, setCanInviteUser] = useState(false);

  useEffect(() => {
    updateUserLimit();
  }, []);

  async function updateUserLimit() {
    const result = await getUserLimit();

    if (result?.data?.data) {
      const resultLimit = result.data.data?.limit;
      const resultCount = result.data.data?.count;
      setUserLimit(resultLimit);
      setUserCount(resultCount);

      setCanInviteUser(resultCount < resultLimit);
    } else {
      setCanInviteUser(false);
    }
  }

  return {
    grid,
    userLimit,
    userCount,
    canInviteUser,
  };
}
